import { Slider } from '@mui/material';
import { styled } from '@mui/system';

const BusHistorySliderControl = styled(Slider)({
    color: '#52af77',
    height: 8,
    '& .MuiSlider-thumb': {
        height: 24,
        width: 24,
        backgroundColor: '#fff',
        border: '2px solid currentColor',
    },
});

export default BusHistorySliderControl;